import styled from 'styled-components';

import { FormComponent } from '../../form';

export const ContactRequestMainContainer = styled.main``;

export const ContactRequestStyledFormContainer = styled(FormComponent)`
    textarea.input {
        height: 200px;
    }
    .alert-additionnal-message .item-legend {
        display: flex;
        align-items: center;
        height: 52px;
        font-size: 12px;
        line-height: 1.2;
        padding: 10px;
        background: ${props => props.theme.customerServiceAlertMessageBackground};
        background-size: auto;

        svg {
            max-width: inherit;
            margin-right: 10px;
        }
    }
    .period .item-legend {
        margin-top: 40px;
    }
    .reason .item-legend {
        margin-top: 20px;
    }
    input[readonly] {
        opacity: 0.5;
        pointer-events: none;
        cursor: not-allowed;
        background: ${props => props.theme.whiteSmoke};
    }

    .information-message {
        margin-top: 15px;
        color: ${props => props.theme.success};

        a {
            color: ${props => props.theme.success};
        }
    }

    .conditions {
        margin-top: 25px;

        h3 {
            margin: 0 0 15px;
        }
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        .alert-additionnal-message .item-legend {
            margin-top: 0;
            height: auto;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/contactrequest/ContactRequestFormComponentStyle.js